import dayjs from 'dayjs';

import { dateIsWithin30Days } from 'utilities/datesAndTimes';

export const getSavingsPercentage = (settlementBalance, outstandingBalance) =>
  outstandingBalance
    ? Math.round((1 - settlementBalance / outstandingBalance) * 100)
    : 0;

// The payment calculator treats start and end dates as inclusive, so without
// the 1-day offset a 6-month plan yields 7 payments. Payments also can't land
// on the expiration date itself. Both cases end the day before.
export const getPaymentPlanEndDate = (
  startDate,
  durationMonths,
  expirationDate,
) => {
  const planEndDate = dayjs(startDate).add(durationMonths, 'month');
  const exclusiveEndDate =
    expirationDate && planEndDate.isAfter(dayjs(expirationDate))
      ? dayjs(expirationDate)
      : planEndDate;
  return exclusiveEndDate.subtract(1, 'day');
};

export const getDefaultPayments = ({
  amount,
  startDate = dayjs(),
  endDate,
  durationMonths,
}) => {
  const weekly = Math.floor(
    dayjs(endDate).diff(dayjs(startDate), 'week', true),
  );
  const biweekly = Math.floor(weekly / 2);

  const perPayment = (periods) =>
    amount && periods > 0 ? Math.round(amount / periods) : null;

  return {
    monthly: perPayment(durationMonths),
    biweekly: perPayment(biweekly),
    weekly: perPayment(weekly),
  };
};

export const getMonthsUntilExpiration = (expirationDate) =>
  expirationDate
    ? Math.max(1, Math.ceil(dayjs(expirationDate).diff(dayjs(), 'month', true)))
    : null;

export const isAfterTodayPaymentCutoff = (date) => {
  const todayPaymentCutoffTimeUtc = dayjs().utc().endOf('day').format();
  return date.isSameOrBefore(todayPaymentCutoffTimeUtc);
};

export const isDate29thTo31st = (selectedDate) => {
  const date = selectedDate.date();
  return date >= 29 && date <= 31;
};

export const disabledPaymentDate = (d) => {
  return !d || !dateIsWithin30Days(d) || isAfterTodayPaymentCutoff(d);
};
